<div class="card card-shadow">
  <div class="card-header bg-white header d-flex justify-content-between">
    <h3 class="fw-bold">Connected Products</h3>
    <span><img src="assets/icons/share.svg" /></span>
  </div>
  <div class="list-group list-group-flush">
    <div class="list-group-item d-flex justify-content-between">
      <div class="d-flex flex-column justify-content-center">
        <span class="fw-bold">Timekeeping</span>
      </div>
      <div class="d-flex flex-column justify-content-center">
        <button class="btn btn-tertiary mb-0" (click)="linkToTimeclock()">View</button>
      </div>
    </div>
  </div>
</div>
